export const availableActions = {
  enhancedSelfEntityOptions: [
    {
      key: 'self/UPDATE',
      label: 'Update',
      icon: 'el-icon-edit',
      description: 'Modify entity properties and information',
      color: '#409EFF',
      bgColor: '#f0f7ff',
      cardClass: 'primary',
    },
    {
      key: 'self/AUTOMATE',
      label: 'Automate',
      icon: 'el-icon-magic-stick',
      description: 'Set up automated workflows and processes',
      color: '#67C23A',
      bgColor: '#f0f9eb',
      cardClass: 'success',
    },
    {
      key: 'self/SEND EMAIL',
      label: 'Notification',
      icon: 'el-icon-message',
      description: 'Send email notifications to relevant parties',
      color: '#E6A23C',
      bgColor: '#fdf6ec',
      cardClass: 'warning',
    },
    {
      key: 'self/SEND WHATSAPP MESSAGE',
      label: 'WA Notification',
      icon: 'el-icon-chat-dot-round',
      description: 'Send WhatsApp messages instantly',
      color: '#25D366',
      bgColor: '#e8f7eb',
      cardClass: 'whatsapp',
    },
    {
      key: 'self/SEND_WORKFLOW',
      label: 'Send Workflow',
      icon: 'el-icon-position',
      description: 'Initiate and distribute workflow processes',
      color: '#909399',
      bgColor: '#f4f4f5',
      cardClass: 'info',
    },
  ],

  // Enhanced other entity options
  enhancedOtherEntityOptions: [
    {
      key: 'other/ADD',
      label: 'Add',
      icon: 'el-icon-circle-plus',
      description: 'Add new related entities or connections',
      color: '#409EFF',
      bgColor: '#f0f7ff',
      cardClass: 'primary',
    },
    {
      key: 'other/UPDATE',
      label: 'Update',
      icon: 'el-icon-edit',
      description: 'Update properties of related entities',
      color: '#409EFF',
      bgColor: '#f0f7ff',
      cardClass: 'primary',
    },
    {
      key: 'other/REFRESH_ENTITY',
      label: 'Refresh entity',
      icon: 'el-icon-refresh',
      description: 'Refresh and sync entity data',
      color: '#67C23A',
      bgColor: '#f0f9eb',
      cardClass: 'success',
    },
    {
      key: 'other/AUTOMATE',
      label: 'Automate',
      icon: 'el-icon-magic-stick',
      description: 'Automate processes for related entities',
      color: '#67C23A',
      bgColor: '#f0f9eb',
      cardClass: 'success',
    },
    //need to check once
    // {
    //   key: 'other/ALLOCATE',
    //   label: 'Auto allocate',
    //   icon: 'el-icon-s-operation',
    //   description: 'Automatically allocate resources or assignments',
    //   color: '#E6A23C',
    //   bgColor: '#fdf6ec',
    //   cardClass: 'warning',
    // },
    {
      key: 'other/ALLOCATION',
      label: 'Auto allocation',
      icon: 'el-icon-s-operation',
      description: 'Automatically allocate resources or assignments',
      color: '#E6A23C',
      bgColor: '#fdf6ec',
      cardClass: 'warning',
    },
  ],

  // Additional actions with enhanced data
  deleteAction: {
    key: 'DELETE',
    label: 'Delete',
    icon: 'el-icon-delete',
    description: 'Permanently remove this entity',
    color: '#F56C6C',
    bgColor: '#fef0f0',
    cardClass: 'danger',
  },

  createContactAction: {
    key: 'CREATE_CONTACT',
    label: 'Create Contact',
    icon: 'el-icon-user-solid',
    description: 'Create a new contact for this business',
    color: '#409EFF',
    bgColor: '#f0f7ff',
    cardClass: 'primary',
  },

  fileManagementActions: [
    {
      key: 'file/ADD_FOLDER',
      label: 'Add Folder',
      icon: 'el-icon-folder-add',
      description: 'Create new folder for organization',
      color: '#67C23A',
      bgColor: '#f0f9eb',
      cardClass: 'success',
    },
    {
      key: 'file/DELETE_FOLDER',
      label: 'Delete Folder',
      icon: 'el-icon-folder-remove',
      description: 'Remove existing folder and contents',
      color: '#F56C6C',
      bgColor: '#fef0f0',
      cardClass: 'danger',
    },
  ],

  documentTemplateActions: [
    {
      key: 'self/doc_template/SEND_DOC_TEMPLATE',
      label: 'Send Document Template',
      icon: 'el-icon-s-promotion',
      description: 'Share document using predefined template',
      color: '#E6A23C',
      bgColor: '#fdf6ec',
      cardClass: 'warning',
    },
  ],

  formBuilderActions: [
    {
      key: 'formbuilder/ADD_FORM',
      label: 'Send Form',
      icon: 'el-icon-document-add',
      description: 'Distribute forms to collect information',
      color: '#409EFF',
      bgColor: '#f0f7ff',
      cardClass: 'primary',
    },
    {
      key: 'formbuilder/SEND_APPROVAL',
      label: 'Send for Approval',
      icon: 'el-icon-s-check',
      description: 'Submit forms for review and approval',
      color: '#67C23A',
      bgColor: '#f0f9eb',
      cardClass: 'success',
    },
  ],

  calendarActions: [
    {
      key: 'self/CREATE_EVENT',
      label: 'Create Event',
      icon: 'el-icon-circle-plus',
      description: 'Schedule new calendar event',
      color: '#409EFF',
      bgColor: '#f0f7ff',
      cardClass: 'primary',
    },
    {
      key: 'self/DELETE_EVENT',
      label: 'Delete Event',
      icon: 'el-icon-remove',
      description: 'Remove scheduled calendar event',
      color: '#F56C6C',
      bgColor: '#fef0f0',
      cardClass: 'danger',
    },
  ],

  externalSourceAction: {
    key: 'external_source',
    label: 'Select Source',
    icon: 'el-icon-setting',
    description: 'Configure external data source integration',
    color: '#909399',
    bgColor: '#f4f4f5',
    cardClass: 'external',
  },
};
